<template>
    <div>
        <ul>
            <li>资源：</li>
            <li v-for="(item, index) in typeDate"
                :class="{'checked-platform-category' : index == resources}"
                @click="changeResources(item.type, index, item.name)"
                :key="item.id"
            >
                <span>{{ item.title }}</span>
            </li>
        </ul>
        <ul v-if="typeDate[resources].children">
            <li>类别：</li>
            <li v-for="(item1, index) in typeDate[resources].children"
                :key="item1.id"
                :class="{'checked-platform-category' : index == resourceChildrens}"
                @click="changeCategory(item1.type, index, item1.title)"
            >
                <span>{{ item1.title }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import { getThingxType } from '../../../network/thingxApi.js'; // 请求零代码类别数据

export default {
    data() {
        return {
            typeDate: [
                {children:''},
                {children:''},
                {children:''}
            ],       // 如果一部返回的数据是二层嵌套，则created不能得到数据，而你的数据使用了二层，故报错，所以把二层名称写死。
            resources: 0,
            resourceChildrens: 0,
            dataListType: [
                "zeroCode/plugins",
                "zeroCode/interfaceTemplate",
                "zeroCode/accessoriesPlugin",
                "zeroCode/chartPlugin",
                "zeroCode/layerPlugin",
                "zeroCode/businessPlugin",
                "zeroCode/twinsPanel",
                "zeroCode/sceneControlPlugin",
                "zeroCode/skinPlugin",
                "zeroCode/corePlugin",
                "zeroCode/extendPlugin",
                "zeroCode/operatingAtom",
                "zeroCode/otherPlugin"
            ]
        }
    },
    props: {
        isZeroCode:{
            type: Number,
        }
    },
    created () {
        // 通过获取路径来定位锚点
        this.init()
    },
    computed: {
        sceneLists(){
            let typeDate =  this.typeDate[this.resources].children;
            return typeDate;
        }
    },
    watch: {
        "$store.state.zeroCode"(){
            if(this.$store.state.zeroCode){
                this.changeResources("zeroCode/getProjects", 0)
                this.changeCategory("zeroCode/getProjects", 0)
            }
        },
        isZeroCode(){
            let pathname = window.location.pathname;
            if(pathname === '/zeroCode/getProjects'||pathname === '/zeroCode'){
                this.changeResources("zeroCode/getProjects", 0)
                this.changeCategory("zeroCode/getProjects", 0)
            }else if(pathname === '/zeroCode/plugins'){
                this.changeResources("zeroCode/plugins", 2)
                this.changeCategory("zeroCode/plugins", 0)
            }else if(pathname === '/zeroCode/tools'){
                this.changeResources("zeroCode/tools", 3)
                this.changeCategory("zeroCode/tools", 0)
            }
        }
    },
    methods: {
        init(){
            getThingxType().then(res =>{
                // 请求零代码类别数据
                this.typeDate = res.content.list;
                //配饰改为标记
                for(let i =0;i<res.content.list[2].children.length;i++) {
                    if(res.content.list[2].children[i].title == '配饰') {
                        res.content.list[2].children[i].title = '标记'
                        break;
                    }
                }
                // 类别定位
                let pathname = window.location.pathname;
                let path = pathname.substring(1,pathname.length)
                let pathIndex = this.dataListType.findIndex((item) =>{
                    return item == path;
                })
                if(path == 'zeroCode/getProjects'){
                    this.changeResources('zeroCode/getProjects', 0)
                    this.$store.commit('setzeroCode', false);
                }else if(this.dataListType.includes(path)){
                    this.changeResources('zeroCode/plugins', 2)
                    this.changeCategory(path, pathIndex)
                }else if(path == 'zeroCode/tools'){
                    this.changeResources('zeroCode/tools', 3)
                    // this.changeCategory(path, pathIndex)
                }

            })
        },
        // 点击资源
        changeResources(type, index, projectName) {
            this.resources = index
            // this.$router.push(type)
            this.$emit("typeDateChange",type);
            this.$store.commit('setzeroCode', false);
            if(index == 0) this.changeCategory('zeroCode/getProjects', 0)
            if(index == 1) this.changeCategory('models', 0)
            if(index == 2) this.changeCategory('zeroCode/plugins', 0)
            if(index == 3) this.changeCategory('zeroCode/tools', 0)

            this.$store.commit('setProjectName', projectName);
        },
        // 点击类别
        changeCategory(type, index, projectName) {
            if(type.includes('getProjects')){   // 如果是项目的话
                this.$store.commit('setProjectLink', index);
            }

            this.resourceChildrens = index
            this.$router.push('/'+type)

            // 触发请求数据接口
            this.$emit("typeDateChange",type);

            this.$store.commit('setProjectName', projectName);
        }
    }
}
</script>

<style lang = "less" scoped>
    .checked-platform-category{
        background: #2fb3ff;
        color: #fff !important;
        border-radius: 13px;
    }
</style>



// WEBPACK FOOTER //
// src/views/thingjsX/typeDate/typeDate.vue